<script>
  export default {
    name: "AtomInput",
    model: { prop: "value", event: "input" },
    props: {
      value: { default: "" },
      type: { type: String, default: "text" },
      id: { type: String, required: true },
      placeholder: { type: String, default: "" },
      disabled: { type: Boolean, default: false },
      required: { type: Boolean, default: false },
      variant: { type: String, default: "primary" },
      styles: { type: Object, default: () => ({}) },
    },
  };
</script>

<template>
  <input
    :id="id"
    :type="type"
    :value="value"
    :style="styles"
    :disabled="disabled"
    :required="required"
    :placeholder="placeholder"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
    @input="$emit('input', $event)"
    :class="['atom-input', `atom-input--${variant}`, { 'atom-input--disabled': disabled }]"
  />
</template>

<style lang="scss">
  .atom-input {
    width: 100%;
    padding: 5px 7.5px;
    border: none;
    outline: none;

    &--primary {
      font-family: $newFont_regular;
      border-radius: 6px;
      background: #f8f8f8;
      font-size: 16px;
      height: 35px;
    }

    &--error {
      border-color: #dc2626;
    }
    &--success {
      border-color: #16a34a;
    }

    &--disabled {
      background: #f3f4f6;
      cursor: not-allowed;
      color: #9ca3af;
    }
  }
</style>
